import { DateInput, required } from "react-admin";
import React, { useEffect, useMemo } from "react";
import { useForm, useFormState } from "react-final-form";

import { get } from "lodash";
import { useSelector } from "react-redux";
import { GroupItem } from "ra-friendsofbabba";

const StartDateInput = ({ source, ...props }) => {
  const { values } = useFormState({ subscription: { values: true } });
  const form = useForm();
  const data = useSelector((state) =>
    get(state, `admin.resources.user-break-reasons.data`)
  );

  const isSingle = get(
    data,
    `${values?.user_break_reason_id}.is_single`,
    false
  );

  const disabled = useMemo(
    () => isSingle || props?.disabled,
    [isSingle, props?.disabled]
  );

  useEffect(() => {
    if (disabled && values?.start) {
      form.change("start", null);
    }
  }, [form, disabled, values?.start]);

  if (isSingle) {
    return null;
  }

  return (
    <GroupItem lg={4} md={5} sm={6} xs={12}>
      <DateInput
        {...props}
        source={source}
        validate={disabled ? null : required()}
        disabled={disabled}
      />
    </GroupItem>
  );
};
export default StartDateInput;
